module.exports = __webpack_public_path__ + "r-v3/img/auto_over.b915320c.jpg";